export default __webpack_public_path__ + "static/media/simone.b10aa426.jpg";